// SVVHlogo image
export const SVVH_LOGO = require("../assets/image/logo.png");
export const STEPS_EN = require("../assets/image/steps_en.svg");
export const STEPS_TH = require("../assets/image/steps_th.svg").default;;
